module.exports = __webpack_public_path__ + "img/ball_8_orange.ebd4b099.png";